import { defineStore } from 'pinia'
import { reactive } from 'vue'
import { HomeAPI } from '@/services/home'
import { get } from 'lodash'

interface ForYouState {
  plateList: any[]
  roleListByPlate: any[]
  festivalRes: any
  loading: boolean
  initialized: boolean
  hasError: boolean
}

const createInitialState = (): ForYouState => ({
  plateList: [],
  roleListByPlate: [],
  festivalRes: {} as any,
  loading: true,
  initialized: false,
  hasError: false
})

export const useForYouStore = defineStore('forYou', () => {
  const state = reactive<ForYouState>(createInitialState())

  const refresh = async () => {
    if (state.initialized) return
    state.loading = true
    state.hasError = false
    try {
      const [plateRes, roleRes, festivalRes] = await Promise.all([
        HomeAPI.getRolePlateList({}),
        HomeAPI.getRoleListByPlate({}),
        HomeAPI.getFestival({})
      ])

      const getData = (res: any): any[] => {
        if (!res) return []
        if (Array.isArray(res.data)) return res.data
        if (Array.isArray(res)) return res
        return []
      }

      state.plateList = getData(plateRes)
      state.roleListByPlate = getData(roleRes)
      state.festivalRes = (festivalRes.data)
      state.initialized = true
    } catch (error) {
      console.error('ForYou 刷新失败:', error)
      state.hasError = true
    } finally {
      state.loading = false
    }
  }

  const refreshForce = async () => {
    state.initialized = false
    await refresh()
  }

  const clear = () => {
    Object.assign(state, createInitialState())
  }

  return {
    state,
    refresh,
    refreshForce,
    clear
  }
})
